export default __webpack_public_path__ + "static/media/Portfolio0.70cf61c2.png";